<div
    fxFlex
    fxLayoutAlign="start start"
    fxLayout.lt-lg="column"
    fxLayoutAlign.lt-lg="start center"
    fxLayoutGap="30px"
    fxLayoutGap.lt-lg="20px"
>
    <div fxLayout="row" style="min-width: 150px">
        <div class="p-16">
            <!-- img [src]="tokenData?.picture" alt="" class="avatar-imagen" / -->
            <img
                *ngIf="foto"
                [src]="foto"
                [alt]="perfilUsuario.rut"
                class="avatar-imagen"
            />
            <br />
            <button
                mat-icon-button
                type="button"
                color="accent"
                (click)="fileInput.click()"
            >
                <mat-icon>edit</mat-icon> Cambiar foto
                <input
                    hidden
                    #fileInput
                    id="foto"
                    type="file"
                    (change)="getFile($event.target.files)"
                />
            </button>
        </div>
    </div>
    <div class="fuse-card" fxLayout="column">
        <div class="p-16">
            <div class="h1 pr-16">Identificación</div>
        </div>

        <mat-list>
            <mat-list-item>
                <h3 matLine>Nombre</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ perfilUsuario.nombres }}
                        {{ perfilUsuario.apellidos }}
                    </span>
                </p>
            </mat-list-item>
            <mat-list-item>
                <h3 matLine>RUT</h3>
                <p matLine>
                    <span class="secondary-text">{{ perfilUsuario.rut }} </span>
                </p>
            </mat-list-item>
            <mat-list-item>
                <h3 matLine>Correo</h3>
                <p matLine>
                    <span class="secondary-text"
                        >{{ perfilUsuario.email }}
                        <button
                            mat-icon-button
                            type="button"
                            color="accent"
                            (click)="editarPerfil()"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                    </span>
                </p>
            </mat-list-item>

            <mat-list-item>
                <p matLine>
                    <button
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="cambiarClave()"
                    >
                        Cambiar Clave
                    </button>
                </p>
            </mat-list-item>
        </mat-list>
    </div>
    <app-roles [roles]="perfilUsuario.roles"></app-roles>
</div>
